import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { STANDARD_CONTRACT_TYPES } from '../contract-types';

export interface ClientContractFilterValues {
  client: string;
  type: string;
  status: string;
}

interface ClientContractFiltersProps {
  initial?: Partial<ClientContractFilterValues>;
  onApply?: (values: ClientContractFilterValues) => void;
  onClear?: () => void;
}

const FILTER_ALL = '__all__';
export { FILTER_ALL };

export function ClientContractFilters({ initial, onApply, onClear }: ClientContractFiltersProps) {
  const [client, setClient] = useState(initial?.client ?? '');
  const [type, setType] = useState(initial?.type ?? FILTER_ALL);
  const [status, setStatus] = useState(initial?.status ?? FILTER_ALL);

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    onApply?.({ client, type, status });
  }

  function handleClear() {
    setClient('');
    setType(FILTER_ALL);
    setStatus(FILTER_ALL);
    onClear?.();
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Filtros de busca</CardTitle>
        <CardDescription>Preencha os filtros abaixo e clique em "Pesquisar".</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <Input
              label="Cliente"
              placeholder="Nome ou CNPJ do cliente"
              value={client}
              onChange={(e) => setClient(e.target.value)}
            />
            <div className="space-y-2">
              <span className="text-sm font-medium text-gray-700">Tipo</span>
              <Select value={type} onValueChange={setType}>
                <SelectTrigger>
                  <SelectValue placeholder="Todos" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value={FILTER_ALL}>Todos</SelectItem>
                  {STANDARD_CONTRACT_TYPES.map((option) => (
                    <SelectItem key={option.id} value={option.id}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <span className="text-sm font-medium text-gray-700">Status</span>
              <Select value={status} onValueChange={setStatus}>
                <SelectTrigger>
                  <SelectValue placeholder="Todos" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value={FILTER_ALL}>Todos</SelectItem>
                  <SelectItem value="active">Ativo</SelectItem>
                  <SelectItem value="inactive">Inativo</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <Button type="button" variant="outline" onClick={handleClear} disabled={!onClear}>
              Limpar
            </Button>
            <Button
              type="submit"
              className="bg-black text-white hover:bg-gray-800"
              disabled={!onApply}
            >
              Pesquisar
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
